module.exports = __webpack_public_path__ + "static/img/icon_monri.dd348b3c.png";